import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Calibration as C } from './Calibration/Calibration';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const Calibration = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Switch>
          <Route path="/organization/:orgId/device/:deviceImei/calibration" component={C} />
        </Switch>
      </Router>
      {/* <ReactQueryDevtools /> */}
    </QueryClientProvider>
  );
};
